import { render, staticRenderFns } from "./SearchDvirDefectsPage.vue?vue&type=template&id=1f92c934&"
import script from "./SearchDvirDefectsPage.vue?vue&type=script&lang=js&"
export * from "./SearchDvirDefectsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports